import React, { useEffect, useState } from 'react';

//import * as images from '../../helpers/images';
import { httpRequest } from '../../helpers/httpService';
import appConfig from '../../config/env';
import helpers from '../../helpers/helpers';

function Footer(){
    const [dswd, setDSWD] = useState('DSWD-SB-SP-00093-2020 valid from July 9, 2020 to July 10, 2021; Nationwide.');
   
    useEffect(() => {
        getGeneralSettings();
    }, []);

    function getGeneralSettings() {
        const url = appConfig.baseUrl + 'api/public/get-options?module=general&only=dswd';

        httpRequest(url, "GET")
            .then((res) => {
                if(res.dswd){
                    setDSWD(res.dswd)
                }
            })
            .catch((err) => {
                //console.log(err)
            });
    }

    return (
        <footer className="bg-dark text-center text-white">
            <div className="text-center p-4" style={{backgroundColor: '#221E20'}}>
                <section className="mb-4">
                <a className="btn btn-outline-light m-1" href="#!"><i className="fab fa-facebook-f" /></a>
                <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fab fa-twitter" /></a>
                <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fab fa-youtube" /></a>
                <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fab fa-linkedin-in" /></a>
                <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fab fa-instagram" /></a>
                </section>
                <span className="copyright">© Copyright {helpers.getFullYear()} World Vision Development Foundation, Inc
                <br />{dswd}</span>
            </div>
        </footer>
    )
}

export default Footer;
